import { useEffect, useRef } from 'react';

// The rights follow the entity: when it changes (after a write), they are asked again.
export const useRefetchOnChange = (
  refetch: () => unknown,
  version: unknown,
): void => {
  const previousVersion = useRef(version);

  useEffect(() => {
    if (previousVersion.current !== version) {
      previousVersion.current = version;
      void refetch();
    }
  }, [refetch, version]);
};
